import { render, staticRenderFns } from "./cookie-category-panels.vue?vue&type=template&id=a9cb6848"
import script from "./cookie-category-panels.vue?vue&type=script&lang=js"
export * from "./cookie-category-panels.vue?vue&type=script&lang=js"
import style0 from "./cookie-category-panels.vue?vue&type=style&index=0&id=a9cb6848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports